/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import Sensor from './Sensor'

/**
 * The InlineResponse20035 model module.
 * @module model/InlineResponse20035
 * @version 1.0.0
 */
export default class InlineResponse20035 {
  /**
   * Constructs a new <code>InlineResponse20035</code>.
   * @alias module:model/InlineResponse20035
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20035</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20035} obj Optional instance to populate.
   * @return {module:model/InlineResponse20035} The populated <code>InlineResponse20035</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20035()

      if (data.hasOwnProperty('url')) {
        obj['url'] = ApiClient.convertToType(data['url'], 'String')
      }
      if (data.hasOwnProperty('sensor')) {
        obj['sensor'] = ApiClient.convertToType(data['sensor'], [Sensor])
      }
    }
    return obj
  }

  /**
   * PointのときはURLを返し、そうでないときは空文字を返す。
   * @member {String} url
   */
  url = undefined
  /**
   * @member {Array.<module:model/Sensor>} sensor
   */
  sensor = undefined
}
